import { Basket } from 'types/common';
import NoResults from './NoResultsText';

interface ListProps {
    data: Basket[];
    loading?: boolean;
    children: (event: Basket, index: number) => any;
}

const List = ({ data, loading = false, children }: ListProps) => {
    if (!data?.length && loading) {
        return null;
    }
    return (
        <div>
            {!data?.length && <NoResults height={200} />}
            {!!data?.length &&
                data.map((event, index) => {
                    return children(event, index);
                })}
        </div>
    );
};

export default List;
